import { SystemText } from 'e4shared';

export const badgeDataRaw = [
    {
        type: 'PROFILE',
        group: 'GENERAL',
        name: 'Autobiographer',
        description: 'Add an image of yourself',
        colour: 'gold',
        icon: 'book',
    },
    {
        type: 'QUARTER',
        group: 'GENERAL',
        name: 'Quarter-Master',
        description: 'Earn an e4 score of at least 100 in a quarter',
        colour: 'gold',
        icon: 'bullseye',
    },
    {
        type: 'STREAK_1',
        group: 'STREAK',
        name: 'Solid Streak',
        description: 'Login 5 weeks in a row',
        colour: 'bronze',
        icon: 'sign-in-alt',
    },
    {
        type: 'STREAK_2',
        group: 'STREAK',
        name: 'Hot Streak',
        description: 'Login 10 weeks in a row',
        colour: 'silver',
        icon: 'sign-in-alt',
    },
    {
        type: 'STREAK_3',
        group: 'STREAK',
        name: 'Sizzling Streak',
        description: 'Login 25 weeks in a row',
        colour: 'gold',
        icon: 'sign-in-alt',
    },
    {
        type: 'TASK_1',
        group: 'TASK',
        name: 'Up and running',
        description: 'Complete first objective',
        colour: 'bronze',
        icon: 'calendar-check',
    },
    {
        type: 'TASK_2',
        group: 'TASK',
        name: 'Keen learner',
        description: 'Complete 10 objectives',
        colour: 'silver',
        icon: 'calendar-check',
    },
    {
        type: 'TASK_3',
        group: 'TASK',
        name: 'Star pupil',
        description: 'Complete 50 objectives',
        colour: 'gold',
        icon: 'calendar-check',
    },
    {
        type: 'POST_1',
        group: 'POST',
        name: 'Budding author',
        description: 'Publish first blog post',
        colour: 'bronze',
        icon: 'comments',
        module: 'blogs',
    },
    {
        type: 'POST_2',
        group: 'POST',
        name: 'Word Smith',
        description: 'Publish 10 blog posts',
        colour: 'silver',
        icon: 'comments',
        module: 'blogs',
    },
    {
        type: 'POST_3',
        group: 'POST',
        name: 'Literary Genius',
        description: 'Publish 25 blog posts',
        colour: 'gold',
        icon: 'comments',
        module: 'blogs',
    },
    {
        type: 'COMMENT_1',
        group: 'COMMENT',
        name: 'Engaged',
        description: 'Comment on a blog post',
        colour: 'bronze',
        icon: 'commenting',
        module: 'blogs',
    },
    {
        type: 'COMMENT_2',
        group: 'COMMENT',
        name: 'Chatty',
        description: 'Comment on 15 blog posts',
        colour: 'silver',
        icon: 'commenting',
        module: 'blogs',
    },
    {
        type: 'COMMENT_3',
        group: 'COMMENT',
        name: 'Commentator',
        description: 'Comment on 50 blog posts',
        colour: 'gold',
        icon: 'commenting',
        module: 'blogs',
    },
    {
        type: 'LIKE_1',
        group: 'LIKE',
        name: 'Supporter',
        description: 'Like a blog post',
        colour: 'bronze',
        icon: 'thumbs-up',
        module: 'blogs',
    },
    {
        type: 'LIKE_2',
        group: 'LIKE',
        name: 'Believer',
        description: 'Like 25 blog posts',
        colour: 'silver',
        icon: 'thumbs-up',
        module: 'blogs',
    },
    {
        type: 'LIKE_3',
        group: 'LIKE',
        name: 'Enthusiast',
        description: 'Like 100 blog posts',
        colour: 'gold',
        icon: 'thumbs-up',
        module: 'blogs',
    },
    {
        type: 'QUESTION_1',
        group: 'QUESTION',
        name: 'Curious',
        description: 'Submit a knowledge bank question',
        colour: 'bronze',
        icon: 'question-circle',
        module: 'knowledge',
    },
    {
        type: 'QUESTION_2',
        group: 'QUESTION',
        name: 'Inquisitive',
        description: 'Submit 10 knowledge bank questions',
        colour: 'silver',
        icon: 'question-circle',
        module: 'knowledge',
    },
    {
        type: 'QUESTION_3',
        group: 'QUESTION',
        name: 'Eager',
        description: 'Submit 25 knowledge bank questions',
        colour: 'gold',
        icon: 'question-circle',
        module: 'knowledge',
    },
    {
        type: 'ANSWER_1',
        group: 'ANSWER',
        name: 'Helpful',
        description: 'Reply to a knowledge bank question',
        colour: 'bronze',
        icon: 'reply',
        module: 'knowledge',
    },
    {
        type: 'ANSWER_2',
        group: 'ANSWER',
        name: 'Supportive',
        description: 'Reply to 10 knowledge bank questions',
        colour: 'silver',
        icon: 'reply',
        module: 'knowledge',
    },
    {
        type: 'ANSWER_3',
        group: 'ANSWER',
        name: 'Philanthropist',
        description: 'Reply to 25 knowledge bank questions',
        colour: 'gold',
        icon: 'reply',
        module: 'knowledge',
    },
    {
        type: 'APP_ANSWER_1',
        group: 'APP_ANSWER',
        name: 'Expert',
        description: 'Have a knowledge bank answer marked as approved',
        colour: 'bronze',
        icon: 'bank',
        module: 'knowledge',
    },
    {
        type: 'APP_ANSWER_2',
        group: 'APP_ANSWER',
        name: 'Authority',
        description: 'Have 10 knowledge bank answers marked as approved',
        colour: 'silver',
        icon: 'bank',
        module: 'knowledge',
    },
    {
        type: 'APP_ANSWER_3',
        group: 'APP_ANSWER',
        name: 'Guru',
        description: 'Have 25 knowledge bank answers marked as approved',
        colour: 'gold',
        icon: 'bank',
        module: 'knowledge',
    },
];

export const badgeData = () =>
    badgeDataRaw.map(d => ({
        ...d,
        name: SystemText(`Badges/${d.type}/Name`),
        description: SystemText(`Badges/${d.type}/Description`),
    }));

export const getBadgeName = type => {
    const badge = badgeData().filter(d => d.type === type);
    return badge.length > 0 ? badge[0].name : type;
};

export const getBadge = type => {
    const badge = badgeData().find(d => d.type === type);
    return badge;
};

export default badgeData;
